import React, { Component } from "react";
import { Fade } from "react-reveal";
import { Helmet } from "react-helmet";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import Button from "../../components/button/Button";
import { dataai, fulls, seo } from "../../portfolio";
import "./HireWebScrapingExpert.css";

class HireWebScrapingExpert extends Component {
  render() {
    const theme = this.props.theme;
    const personalImage = "/images/personal-img.png";
    const fallbackImage = require("../../assests/images/walid-bg.png");
    const scrapingProjects = [...dataai.data, ...fulls.data].slice(0, 6);

    const shortProjectTitle = (name) => {
      const customTitles = {
        "Extracting all Facebook posts and comments of the UNITED Facebook page":
          "Facebook Posts and Comments Extraction",
      };

      if (customTitles[name]) {
        return customTitles[name];
      }

      if (name.length <= 62) {
        return name;
      }

      return `${name.slice(0, 59).trim()}...`;
    };

    const simplifyOutcome = (project) => {
      const content = `${project.name} ${project.description}`.toLowerCase();

      if (/job|ats|greenhouse|lever|bamboohr|breezy|workable/.test(content)) {
        return "Track new job postings automatically so your team can move faster than competitors.";
      }

      if (/price|tesco|amazon|marketplace/.test(content)) {
        return "Monitor product prices and changes across locations to support better pricing and purchasing decisions.";
      }

      if (/facebook|instagram|flickr|kijiji/.test(content)) {
        return "Collect large volumes of public social and marketplace data so you can spot trends and opportunities quickly.";
      }

      if (/law|legal|westlaw|heinonline/.test(content)) {
        return "Gather legal records in one place to reduce research time and make analysis easier.";
      }

      return "Turn manual copy-paste work into a reliable, repeatable process that saves time and improves decision making.";
    };

    const reviews = [
      {
        title: "Data Harvesting",
        period: "Mar 3, 2022 - Mar 5, 2022",
        quote:
          "Very satisfied with his work. He did exactly as I asked, and I recommend him for future work.",
      },
      {
        title: "Phone Platform Web Scraping",
        period: "Jan 4, 2024 - Jan 11, 2024",
        quote: "Delivered reliably and on time with great quality.",
      },
      {
        title: "PDF to Excel Automation",
        period: "Jan 18, 2022 - Jan 27, 2022",
        quote: "Great communication and good and fast work.",
      },
      {
        title: "Twitter Data Project",
        period: "Apr 1, 2024 - Apr 3, 2024",
        quote: "Fast turnaround and easy collaboration.",
      },
      {
        title: "TEI XML Conversion",
        period: "Aug 17, 2023 - Nov 14, 2023",
        quote:
          "Walid's quick learning and flexibility stand out. Great communication and seamless project collaboration.",
      },
      {
        title: "TV Guide to XMLTV Parser",
        period: "Nov 4, 2020 - Nov 10, 2020",
        quote:
          "Outstanding job again. High quality work that kept working even after websites changed.",
      },
      {
        title: "Data Scrape",
        period: "Nov 3, 2020 - Nov 17, 2020",
        quote:
          "Very punctual and asked the right questions to complete the task correctly.",
      },
      {
        title: "Real Estate Data Scraping",
        period: "Jul 25, 2023 - Aug 7, 2023",
        quote:
          "Best freelancer I worked with on Upwork. Even created a tutorial to keep the script running easily.",
      },
    ];

    const getEndMonthYear = (period) => {
      const endPart = period.split("-").pop()?.trim() || "";
      const match = endPart.match(/^([A-Za-z]+)\s+\d{1,2},\s+(\d{4})$/);
      if (!match) return endPart;
      return `${match[1]} ${match[2]}`;
    };

    const scrollToReviews = () => {
      const reviewsSection = document.getElementById("client-reviews");
      if (reviewsSection) {
        reviewsSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    };

    return (
      <div className="hire-scraping-main">
        <Helmet>
          <title>{seo.title}</title>
          <meta
            name="description"
            content="Save hours of manual work with automated data collection. Get accurate data, cleaner workflows, and faster decisions for your business."
          />
          <meta
            name="keywords"
            content="hire web scraping expert, web scraper developer, web scraping freelancer, custom web scraping"
          />
        </Helmet>

        <Header theme={theme} />

        <div className="hire-scraping-content">
          <Fade bottom duration={1000} distance="30px">
            <section className="hire-hero">
              <div className="hire-hero-inner">
                <div className="hire-hero-text">
                  <p
                    className="hire-badge"
                    style={{
                      color: theme.text,
                      backgroundColor: theme.highlight,
                    }}
                  >
                    <i className="fas fa-bolt hire-inline-icon"></i>
                    Save Time with Better Data
                  </p>
                  <h1 className="hire-title" style={{ color: theme.text }}>
                    Web Scraping Expert
                  </h1>
                  <p
                    className="hire-subtitle subTitle"
                    style={{ color: theme.secondaryText }}
                  >
                    I automate website data collection so your team saves time
                    and gets accurate data delivered on schedule.
                  </p>
                  <div className="hire-cta-row">
                    <Button
                      text="Email Me Directly"
                      href="mailto:maaninou.walid@gmail.com?subject=Web%20Scraping%20Project"
                      newTab={false}
                      theme={theme}
                    />
                    <Button
                      text="Message Me on Telegram"
                      href="https://t.me/walidMaaninou"
                      newTab={true}
                      theme={theme}
                    />
                  </div>
                </div>
                <div className="hire-hero-image-wrap">
                  <div className="hire-hero-side">
                    <div className="hire-hero-image-frame">
                      <img
                        className="hire-hero-image"
                        src={personalImage}
                        onError={(event) => {
                          event.currentTarget.onerror = null;
                          event.currentTarget.src = fallbackImage;
                        }}
                        alt="Walid Maaninou"
                      />
                      <div className="hire-image-overlay"></div>
                    </div>
                    <div className="hire-hero-trust-cards">
                      <article
                        className="hire-trust-card"
                        style={{ borderColor: theme.headerColor }}
                      >
                        <h3 style={{ color: theme.text }}>
                          <i className="fas fa-medal hire-inline-icon"></i>
                          Reputation
                        </h3>
                        <p style={{ color: theme.secondaryText }}>
                          Top Rated on Upwork.
                        </p>
                      </article>
                      <article
                        className="hire-trust-card"
                        style={{ borderColor: theme.headerColor }}
                      >
                        <h3 style={{ color: theme.text }}>
                          <i className="fas fa-dollar-sign hire-inline-icon"></i>
                          Earnings
                        </h3>
                        <p style={{ color: theme.secondaryText }}>
                          $90k+ earned on Upwork.
                        </p>
                      </article>
                      <article
                        className="hire-trust-card hire-trust-card-clickable"
                        style={{ borderColor: theme.headerColor }}
                        role="button"
                        tabIndex={0}
                        onClick={scrollToReviews}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            scrollToReviews();
                          }
                        }}
                      >
                        <h3 style={{ color: theme.text }}>
                          <i className="fas fa-star hire-inline-icon"></i>
                          Reviews
                        </h3>
                        <p style={{ color: theme.secondaryText }}>
                          See real client reviews.
                        </p>
                      </article>
                    </div>
                    <div className="hire-hero-trust-cta">
                      <Button
                        text="Visit My Upwork Profile"
                        href="https://www.upwork.com/freelancers/walidmaaninou"
                        newTab={true}
                        theme={theme}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </Fade>

          <Fade bottom duration={1000} distance="30px">
            <section className="hire-section">
              <h2 className="hire-section-title" style={{ color: theme.text }}>
                <i className="fas fa-chart-line hire-inline-icon"></i>
                What You Get
              </h2>
              <div className="hire-grid">
                <article
                  className="hire-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <h3 style={{ color: theme.text }}>
                    <i className="far fa-clock hire-inline-icon"></i>
                    More Time Every Week
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    Stop repetitive copy-paste tasks. Your team gets back hours
                    every week for sales, operations, and customer support.
                  </p>
                </article>
                <article
                  className="hire-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <h3 style={{ color: theme.text }}>
                    <i className="fas fa-lightbulb hire-inline-icon"></i>
                    Better Decisions with Better Data
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    Get clean, organized data you can use right away in sheets,
                    dashboards, reports, and day-to-day planning.
                  </p>
                </article>
                <article
                  className="hire-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <h3 style={{ color: theme.text }}>
                    <i className="fas fa-calendar-check hire-inline-icon"></i>
                    Reliable Weekly Results
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    Keep your pipeline running on schedule so you always have
                    fresh data when you need it, without manual follow-up.
                  </p>
                </article>
              </div>
            </section>
          </Fade>

          <Fade bottom duration={1000} distance="30px">
            <section className="hire-section">
              <h2 className="hire-section-title" style={{ color: theme.text }}>
                <i className="fas fa-route hire-inline-icon"></i>
                How It Works
              </h2>
              <div className="hire-process-map">
                <article
                  className="hire-process-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <span className="hire-process-number">01</span>
                  <h3 style={{ color: theme.text }}>
                    <i className="fas fa-comments hire-step-icon"></i>
                    Quick Call
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    You share your goal and the websites you care about.
                  </p>
                </article>
                <article
                  className="hire-process-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <span className="hire-process-number">02</span>
                  <h3 style={{ color: theme.text }}>
                    <i className="fas fa-vial hire-step-icon"></i>
                    First Sample
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    I deliver a sample result so you can confirm it matches your
                    needs.
                  </p>
                </article>
                <article
                  className="hire-process-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <span className="hire-process-number">03</span>
                  <h3 style={{ color: theme.text }}>
                    <i className="fas fa-tools hire-step-icon"></i>
                    Full Setup
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    I set up the full workflow so data keeps updating on
                    schedule.
                  </p>
                </article>
                <article
                  className="hire-process-card"
                  style={{ borderColor: theme.headerColor }}
                >
                  <span className="hire-process-number">04</span>
                  <h3 style={{ color: theme.text }}>
                    <i className="fas fa-life-ring hire-step-icon"></i>
                    Ongoing Support
                  </h3>
                  <p style={{ color: theme.secondaryText }}>
                    If needed, I maintain and adjust the automation over time.
                  </p>
                </article>
              </div>
            </section>
          </Fade>

          <Fade bottom duration={1000} distance="30px">
            <section className="hire-section">
              <h2 className="hire-section-title" style={{ color: theme.text }}>
                <i className="fas fa-briefcase hire-inline-icon"></i>
                Past Work Highlights
              </h2>
              <div className="hire-projects-grid">
                {scrapingProjects.map((project) => (
                  <article
                    key={project.id + project.name}
                    className="hire-project-card"
                  >
                    <h3 style={{ color: theme.text }}>
                      {shortProjectTitle(project.name)}
                    </h3>
                    <p style={{ color: theme.secondaryText }}>
                      {simplifyOutcome(project)}
                    </p>
                  </article>
                ))}
              </div>
            </section>
          </Fade>

          <Fade bottom duration={1000} distance="30px">
            <section className="hire-section" id="client-reviews">
              <h2 className="hire-section-title" style={{ color: theme.text }}>
                <i className="fas fa-star hire-inline-icon"></i>
                Client Reviews
              </h2>
              <div className="hire-reviews-slider">
                <div className="hire-reviews-track">
                  {[...reviews, ...reviews].map((review, index) => (
                    <article
                      key={`${review.title}-${index}`}
                      className="hire-review-card"
                      style={{ borderColor: theme.headerColor }}
                    >
                      <h3 style={{ color: theme.text }}>{review.title}</h3>
                      <p
                        className="hire-review-stars"
                        aria-label="5 out of 5 stars"
                      >
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <i className="fas fa-star"></i>
                        <span>5.0</span>
                      </p>
                      <p
                        className="hire-review-meta"
                        style={{ color: theme.secondaryText }}
                      >
                        {getEndMonthYear(review.period)}
                      </p>
                      <p
                        className="hire-review-quote"
                        style={{ color: theme.secondaryText }}
                      >
                        "{review.quote}"
                      </p>
                    </article>
                  ))}
                </div>
              </div>
              <div className="hire-reviews-cta">
                <Button
                  text="Still Not Sure? Check Reviews on My Upwork Profile"
                  href="https://www.upwork.com/freelancers/walidmaaninou"
                  newTab={true}
                  theme={theme}
                />
              </div>
            </section>
          </Fade>

          <Fade bottom duration={1000} distance="30px">
            <section
              className="hire-final-cta"
              style={{ backgroundColor: theme.highlight }}
            >
              <h2 style={{ color: theme.text }}>
                <i className="fas fa-paper-plane hire-inline-icon"></i>
                Want to stop losing time on repetitive online tasks?
              </h2>
              <p style={{ color: theme.secondaryText }}>
                Tell me what you want automated. I will reply with a simple plan
                focused on time saved, quality, and business impact.
              </p>
              <div className="hire-cta-row">
                <Button
                  text="Email Me"
                  href="mailto:maaninou.walid@gmail.com?subject=Automation%20Project%20Inquiry"
                  newTab={false}
                  theme={theme}
                />
                <Button
                  text="Telegram @walidMaaninou"
                  href="https://t.me/walidMaaninou"
                  newTab={true}
                  theme={theme}
                />
              </div>
            </section>
          </Fade>
        </div>

        <Footer theme={theme} />
        <TopButton theme={theme} />
      </div>
    );
  }
}

export default HireWebScrapingExpert;
